/**
 * 主题工具模块
 * 提供全局主题色获取方法，供 JS/Vue 组件动态使用
 */

/**
 * 获取当前主题的主色
 * @returns {string} 当前主题主色的 hex 值
 */
export function getThemePrimaryColor() {
    const appRoot = document.getElementById(`app`)
    const themeRoot = (appRoot && appRoot.parentElement) || document.body || document.documentElement
    const val = getComputedStyle(themeRoot).getPropertyValue(`--primary-color`).trim()
    return val || `#009688`
}

/**
 * 获取当前主题名称
 * @returns {string} 当前主题 class 名
 */
export function getCurrentTheme() {
    return localStorage.getItem(`app_theme`) || `theme-dark`
}

/**
 * 判断当前是否为 HIS 蓝色主题
 * @returns {boolean}
 */
export function isHisBlueTheme() {
    return getCurrentTheme() === `theme-his-blue`
}

/**
 * 主题色板 - HIS 蓝色主题
 */
export const HIS_BLUE_PALETTE = {
    primary: `#549BFB`,
    primaryHover: `#66AEFF`,
    primaryActive: `#3B78D4`,
    primaryDisabled: `#9FCEFF`,
    tableSelectedBg: `#BADBFE`,
    tableHoverBg: `#E1EFFD`,
    tableHeaderBg: `#E2E9F2`,
    navStart: `#31478F`,
    navEnd: `#549BFB`,
    success: `#2eae65`,
    warning: `#FF8A01`,
    error: `#E14E4D`
}

/**
 * 主题色板 - 默认主题
 */
export const DEFAULT_PALETTE = {
    primary: `#009688`,
    primaryHover: `#00897b`,
    primaryActive: `#00796b`,
    primaryDisabled: `#80cbc4`,
    tableSelectedBg: `rgba(0, 150, 136, 0.2)`,
    tableHoverBg: `rgba(0, 150, 136, 0.2)`,
    tableHeaderBg: `#f5f7fa`,
    navStart: `#1f2d3d`,
    navEnd: `#1f2d3d`,
    success: `#2eae65`,
    warning: `#FF8A01`,
    error: `#E14E4D`
}

/**
 * 获取当前主题的完整色板
 * @returns {object} 色板对象
 */
export function getThemePalette() {
    return isHisBlueTheme() ? HIS_BLUE_PALETTE : DEFAULT_PALETTE
}

/**
 * Vue Mixin - 在组件中暴露 $themePrimary 计算属性
 * 用法: 在需要的组件中 mixins: [themeMixin]
 */
export const themeMixin = {
    computed: {
        $themePrimary() {
            return getThemePrimaryColor()
        },
        $themePalette() {
            return getThemePalette()
        },
        $isHisBlue() {
            return isHisBlueTheme()
        }
    }
}

export default {
    getThemePrimaryColor,
    getCurrentTheme,
    isHisBlueTheme,
    getThemePalette,
    HIS_BLUE_PALETTE,
    DEFAULT_PALETTE,
    themeMixin
}



// WEBPACK FOOTER //
// ./src/utils/theme.js